<template>
  <section class="container content-padding">
    <div class="row">
      <div class="col-sm-8 offset-sm-2 col-12">
        <h2>{{ $t('message.recruting.title') }}</h2>

        <div class="card panel-white" v-if="jobPost">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b>{{ $t('message.recruting.code') }}</b> #{{ jobPost.code }}
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                {{ jobPost.title }}
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.recruting.description') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ jobPost.description }}
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-4 text-left">
                <label>{{ $t('message.recruting.interviews') }}</label>
              </div>
            </div>
            <div class="row social-box">
              <template v-for="(item, index) in jobPost.job_users">
                <div class="col-6 text-center" v-if="item.job_user">
                  <div class="box card">
                    <div class="box-title">
                      <img :src="item.job_user.picture" class="card-img-top" style="height: 180px; width: auto;">
                      <h3 class="mt-3"> {{ item.job_user.prefix_name }} {{ item.job_user.name }}</h3>
                    </div>
                    <div class="box-text text-left">
                      <span> <b>{{ $t('message.recruting.age') }}</b>: {{ calculateAge(item.job_user.birth_date) }}</span> <br>
                      <span> <b>{{ $t('message.recruting.introduce') }}</b>: {{ item.job_user.introduce }}</span> <br>
                      <span> <b>{{ $t('message.recruting.working_experience') }}</b>: {{ item.job_user.working_experience }}</span>
                    </div>
                  <!-- <div class="box-btn">
                      <a href="#">Learn More</a>
                    </div>-->
                  </div>
                </div>

              </template>
            </div>
          </div>

        </div>
        <div class="row" v-else>
          <div class="col text-center">
            <div class="mb-3">
              <i class="fal fa-times-circle -status-alert fa-3x"></i>
            </div>
            <h2>Not Found</h2>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RecrutingDetail',
  data () {
    return {
      jobPost: null
    }
  },
  methods: {
    async getRecruting () {
      let recrutingId = this.$route.params.id
      let validationQuery = this.$route.query.validation
      let { data } = await axios.get('/job-posts/' + recrutingId + '/review', {
        params: {
          validation: validationQuery
        }
      })
      if (data.error) {
        this.$swal({ text: data.message, type: 'error' })
      } else {
        this.jobPost = data.job_post
      }
    },
    calculateAge (birthday) {
      if (!birthday) {
        return ''
      }
      let birthdayDate = new Date(birthday)
      let ageDifMs = Date.now() - birthdayDate.getTime()
      let ageDate = new Date(ageDifMs)
      return Math.abs(ageDate.getUTCFullYear() - 1970)
    }
  },
  created () {
    this.getRecruting()
  }
}
</script>

<style scoped lang="scss">


.social-box .box {
  background: #FFF;
  border-radius: 10px;
  padding: 40px 10px;
  margin: 20px 0px;
  cursor: pointer;
  transition: all 0.5s ease-out;
}

.social-box .box:hover {
  box-shadow: 0 0 6px #4183D7;
}

.social-box .box .box-text {
  margin: 10px 0px;
  font-size: 15px;
  line-height: 30px;
}

.social-box .box .box-btn a {
  text-decoration: none;
  color: #4183D7;
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/recruting/RecrutingDetail.vue